export const MOBILE_HOME_HEADER_BUTTON_HITSLOP_SIZE = 40;
export const MOBILE_HOME_HEADER_ICON_SIZE = 24;
